<template>
  <div>
    <vs-card clas="w-full">
      <!-- Cabeçalho -->
      <div slot="header"><h3>Relatório</h3></div>

      <!-- Mensagem inicial -->
      <h6 v-if="relatorio.length == 0">
        Selecione as opções acima para gerar o seu relatório.
      </h6>

      <!-- Relatório Gerado -->
      <div v-else>
        <!-- Botões -->
        <div class="flex gap-2 justify-end my-3 flex-col lg:flex-row">
          <vs-button icon="star" color="warning" @click="abreModalFavoritos"
            >Salvar nos Favoritos
          </vs-button>

          <vs-button
            v-if="relatorio.length > 0 && relatorioCompletoGerado == false"
            color="dark"
            icon="file_download"
            @click="
              $emit('relatorioDownload'), (relatorioCompletoGerado = true)
            "
            >Gerar tabela para download
          </vs-button>

          <vs-button
            v-if="relatorio.length > 0 && relatorioCompletoGerado == true"
            color="primary"
            icon="file_download"
            @click="exportToExcel()"
            >Download</vs-button
          >
        </div>

        <!-- Tabela -->
        <vs-table class="table-relatorio-dinamico" :data="relatorio" stripe>
          <!-- Resumo -->
          <template slot="header">
            <div>
              <div v-if="quantidadeItens > 0" class="m-3">
                {{ quantidadeItens }}
                {{
                  quantidadeItens == 1
                    ? 'registro encontrado'
                    : 'registros encontrados'
                }}
              </div>
            </div>
          </template>

          <!-- Colunas -->
          <template slot="thead">
            <vs-th v-for="(item, index) in colunas" :key="index">
              {{ item }}
            </vs-th>
          </template>

          <!-- Valores -->
          <template slot-scope="{ data }">
            <vs-tr
              :key="indexItemRelatorio"
              v-for="(itemRelatorio, indexItemRelatorio) in data"
            >
              <vs-td
                v-for="(item, key) in itemRelatorio"
                :key="key"
                :data="data[indexItemRelatorio]"
              >
                <span
                  v-if="key.toLowerCase().includes('link') && item"
                  @click="geraLink(item, key)"
                  class="cursor-pointer flex items-center gap-2"
                >
                  {{ item }}
                  <vs-icon icon="open_in_new" color="rgb(0,191,237)" />
                </span>

                <span v-else>{{ item }}</span>
                <!-- {{ item }} -->
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>

        <!-- Paginação -->
        <vs-pagination
          v-model="paginaAtual"
          :total="quantidadePaginas"
          class="mt-5"
        ></vs-pagination>
      </div>

      <vs-card class="mt-5" v-if="resumo && resumo.length > 0">
        <div slot="header">
          <h3 class="my-3"><span class="resumoTitle">RESUMO</span></h3>
        </div>
        <FormResumoRelatorio :dadosResumo="resumo"></FormResumoRelatorio>
      </vs-card>
    </vs-card>

    <!-- TABELAS OCULTAS -->
    <!-- Tabela oculta do relatório para formatação do excel -->
    <div>
      <table id="1" class="hidden">
        <thead>
          <th v-for="(nomeColuna, index) in colunas" :key="index">
            {{ nomeColuna }}
          </th>
        </thead>
        <tbody>
          <tr
            v-for="(registro, indexRegistro) in relatorioCompleto"
            :key="indexRegistro"
          >
            <td v-for="(item, index) in registro" :key="index">{{ item }}</td>
          </tr>
        </tbody>
      </table>

      <!-- Tabela oculta do resumo para formatação do excel -->
      <table id="2" class="hidden">
        <tr>
          <td>{{ ' ' }}</td>
        </tr>
        <tr>
          <td>{{ ' ' }}</td>
        </tr>
        <tr>
          <td>{{ ' ' }}</td>
        </tr>
        <tr>
          <th>RESUMO</th>
        </tr>
        <thead>
          <th v-for="(nomeColunaResumo, index) in colunasResumo" :key="index">
            {{ nomeColunaResumo }}
          </th>
        </thead>
        <tbody>
          <tr
            v-for="(registroResumo, indexRegistroResumo) in resumo"
            :key="indexRegistroResumo"
          >
            <td
              v-for="(itemResumo, indexResumo) in registroResumo"
              :key="indexResumo"
            >
              {{ itemResumo }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import notify from '../../../../../utils/notify';
import FormResumoRelatorio from './FormResumoRelatorio.vue';

export default {
  props: ['relatorioGerado', 'qtdPaginas', 'resumo'],

  components: {
    FormResumoRelatorio,
  },

  data() {
    return {
      colunas: [],
      colunasResumo: [],
      valores: [],
      relatorio: [],
      relatorioCompleto: [],

      paginaAtual: 1,
      quantidadePaginas: 0,
      relatorioCompletoGerado: false,
    };
  },

  watch: {
    relatorioCompleto(value) {
      this.relatorioCompleto = value;
    },

    relatorioGerado(value) {
      if (value.length == 0) {
        notify.notifyFail(this.$vs, 'Não há resultados com essa consulta.');
        return;
      }
      this.relatorioCompletoGerado = false;
      this.relatorio = value;
      this.preparaTabela();
    },

    paginaAtual() {
      this.$emit('mudaPagina', this.paginaAtual);
    },

    qtdPaginas(value) {
      this.quantidadePaginas = value;
    },
  },

  methods: {
    geraLink(id, key) {
      if (key == 'Id/Link do Associado') {
        window.open(
          `${window.location.origin}/DetalheAssociado/${id}`,
          '_blank',
        );
      }

      if (key == 'Protocolo/Link do Protocolo') {
        let protocoloId = '';
        if (id[0] == 'A') {
          protocoloId = id.substring(5);
        }
        if (id[0] == 'T') {
          protocoloId = id.substring(6);
        }
        window.open(`${window.location.origin}/evento-analise/${protocoloId}`);
      }

      if (key == 'Link do Boleto') {
        window.open(id);
      }
    },

    geraCompletoParaDownload() {
      this.$emit('relatorioDownload');
    },

    abreModalFavoritos() {
      this.$emit('abreModalFavoritos', true);
    },

    preparaTabela() {
      this.colunas = Object.keys(this.relatorio[0]);

      this.relatorio.forEach((item) => {
        this.valores.push(Object.values(item));
      });
    },

    exportToExcel() {
      const uri = 'data:application/vnd.ms-excel;charset=UTF-8;base64,';
      const template =
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta name=ProgId content=Excel.Sheet> <meta name=Generator content="Microsoft Excel 11"><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets>';
      const templateend =
        '</x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head>';
      const body = '<body>';
      const tablevar = '<table>{table';
      const tablevarend = '}</table>';
      const bodyend = '</body></html>';
      const worksheet = '<x:ExcelWorksheet><x:Name>';
      const worksheetend =
        '</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet>';
      const worksheetvar = '{worksheet';
      const worksheetvarend = '}';

      const base64 = function (s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      };

      const format = function (s, c) {
        return s.replace(/{(\w+)}/g, function (m, p) {
          return c[p];
        });
      };
      let wstemplate = '';
      let tabletemplate = '';

      const tables = [1, 2];
      const name = ['Relatório'];

      for (let i = 0; i < tables.length; ++i) {
        wstemplate +=
          worksheet + worksheetvar + i + worksheetvarend + worksheetend;
        tabletemplate += tablevar + i + tablevarend;
      }

      const allTemplate = template + wstemplate + templateend;
      const allWorksheet = body + tabletemplate + bodyend;
      const allOfIt = allTemplate + allWorksheet;

      const ctx = {};
      for (var j = 0; j < tables.length; ++j) {
        ctx['worksheet' + j] = name[j];
      }

      for (let k = 0; k < tables.length; ++k) {
        let exceltable;
        if (!tables[k].nodeType)
          exceltable = document.getElementById(tables[k]);
        ctx['table' + k] = exceltable.innerHTML;
      }

      var myBlob = new Blob([format(allOfIt, ctx)], { type: 'text/html' });
      var url = window.URL.createObjectURL(myBlob);
      var a = document.createElement('a');
      document.body.appendChild(a);
      a.href = url;
      a.download = 'download.xls';
      a.click();

      setTimeout(function () {
        window.URL.revokeObjectURL(url);
      }, 0);

      //window.location.href = uri + base64(format(allOfIt, ctx));
    },
  },
};
</script>
<style scoped>
.resumoTitle {
  background: #e1f6ff;
  color: #0090cf;
  padding: 0.5rem 1rem;
  border-radius: 10px;
  font-weight: bold;
}
</style>
<style>
.table-relatorio-dinamico .vs-table--tbody {
  z-index: 0;
}
</style>
